import ProfilePanel from '~/statistics-v2/components/ProfilePanel'
import { useGetUserDetails } from '~/statistics-v2/hooks/useGetUserDetails'
import { HeaderStats } from '~/statistics-v2/types/statistics.types'
import { IUser } from '~/types/user-info-types'

/**
 * `ProfilePanel` for the signed-in learner, or for a family member when `user` is given.
 *
 * ⚠ b2c only. `useGetUserDetails` resolves level from the signed-in user's points and league from
 * `?familyMemberId=`, neither of which means anything outside a family.
 */
export default function ProfileHeader({
  headerStats,
  isLoading = false,
  user,
}: {
  headerStats: HeaderStats
  isLoading?: boolean
  user?: IUser
}): React.ReactElement {
  const {
    nickname,
    avatarImageObject,
    userTitle,
    userLevel,
    gradeTitle,
    currentLeagueName,
    currentLeagueIconUrl,
    curentLeagueRank,
  } = useGetUserDetails(false, user)

  return (
    <ProfilePanel
      avatar={avatarImageObject}
      gradeTitle={gradeTitle}
      headerStats={headerStats}
      isLoading={isLoading}
      league={{ iconUrl: currentLeagueIconUrl, name: currentLeagueName as string, rank: curentLeagueRank }}
      level={userLevel}
      name={nickname}
      userTitle={userTitle}
    />
  )
}
